import { useState } from "react";

import NumberInputText from "../../controls/inputs/NumberInputText";
import { classNames } from "primereact/utils";
import Input from "../../controls/Input";

export default function AddServiceToOrderModal(props) {
  const { service, confirmAction, setOpen } = props;

  const [values, setValues] = useState({
    id: service.id,
    service_id: service.value,
    service_name: service.label,
    service_type: service.type,
    quantity: service.quantity,
    option_selected: service.option_selected,
    multi_options: service.multi_options,
    item: service.item,
  });

  return (
    <div className="justify-between">
      <div>
        <div className="flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Add <span className="font-bold">{values.service_name}</span> to
              work order
            </h3>
          </div>
        </div>

        <div className="py-1 gap-4 bg-white sm:rounded-xl space-y-4">
          <div className="grid grid-cols-1 gap-4 w-full">
            <NumberInputText
              label="Quantity"
              name="quantity"
              onChange={(e) =>
                setValues({ ...values, quantity: e.target.value })
              }
              value={values.quantity}
              labelOn={true}
            />
          </div>

          <div
            className={classNames(
              service.type === 0 ? "grid grid-cols-1 gap-4 w-full" : "hidden"
            )}
          >
            <Input
              label="Item"
              name="item"
              onChange={(e) => setValues({ ...values, item: e.target.value })}
              value={values.item}
              labelOn={true}
            />
          </div>

          <div>
            {service.multi_options.map((option) => (
              <div className="flex items-center">
                <input
                  checked={values.option_selected === option.id}
                  name="option-input"
                  type="radio"
                  className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden"
                  onClick={(e) =>
                    setValues({ ...values, option_selected: option.id })
                  }
                />
                <label
                  htmlFor="option-input"
                  className="ml-3 block text-sm/6 font-medium text-gray-900"
                >
                  {option.name}
                </label>
              </div>
            ))}
          </div>

          <div className="sm:flex-no-wrap my-auto flex items-center">
            <button
              onClick={() => {
                confirmAction(values);
                setOpen({
                  open: false,
                });
              }}
              className="inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center"
            >
              OK
            </button>
            <button
              onClick={() =>
                setOpen({
                  open: false,
                })
              }
              className="ml-2 inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 items-center"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
